import React, { useCallback, useState, memo } from "react";
import {
  AppBar,
  Box,
  ListItemButton,
  Toolbar,
  Typography,
  useTheme,
} from "@mui/material";
import {
  List,
  ListItemText,
  ListItemIcon,
  Container,
  Paper,
} from "@mui/material";
import _ from "lodash";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import Icone from "./icone";
import { DrawerExibicao, InputBusca } from ".";

//Estilizacoes
const sxAppBar = {
  top: "auto",
  bottom: 0,
  width: "100vw",
};
//
const sxItemAppBar = {
  display: "flex",
  padding: "4px",
  flex: 1,
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
};
//
const sxIcone = {
  color: (theme) =>
    theme.palette.mode === "dark" ? "white" : theme.palette.primary.main,
};
//
const sxMenuDrawer = { height: "85vh" };
//
const sxBarraBusca = { my: 0 };

const BarraInferior = ({ menuSPA }) => {
  // Estado para controlar o drawer
  const [exibir, setExibir] = useState(false);
  // Estado para controlar a busca do menu pelo termo
  const [busca, setBusca] = useState(null);

  // Para saltar entre as opcoes
  const history = useHistory();
  const menu = useSelector((state) => state?.usuario?.menus);
  // Se o menu nao tiver sido recuperado ainda envie um objeto vazio
  const MENUS = menu || {};
  // Conta a quantidade de menus disponiveis, se ultrapassar 3 o quarto será um icone de menu
  let contador = 1;
  // Itens do menu
  const ITENS_MENU = [];
  const ITENS_EXCEDENTES = [];
  // Funcao de callback para controlar o acesso as rotas
  const onClick = useCallback(
    (rota) => {
      if (menuSPA.includes(rota)) {
        history.replace(rota);
        setExibir(false);
      } else {
        window.location.href = rota;
      }
    },
    [history, menuSPA, setExibir]
  );

  Object.keys(MENUS).forEach((key) => {
    MENUS[key].forEach((arr) => {
      if (contador < 4) {
        ITENS_MENU.push({
          texto: arr[3],
          onClick: () => onClick(arr[0]),
          //icone: ICONES[key],
          icone: arr[2],
        });
      } else if (contador === 4) {
        // Icone de menu pois o excesso começa agora
        ITENS_MENU.push({
          texto: "Menu",
          onClick: () => setExibir(true),
          icone: "Menu",
        });
      }

      if (contador > 3) {
        // O contador ja excedeu o limite itens excedentes aqui
        ITENS_EXCEDENTES.push({
          link: arr[0],
          texto: arr[1],
          onClick: () => onClick(arr[0]),
          //icone: ICONES[key],
          icone: arr[2],
        });
      }
      // Atualizando o contador
      contador++;
    });
  });

  let corpo;
  if (exibir) {
    // Se tiver uma busca nos itens excedentes aplicar o filtro

    corpo = (
      <Container sx={sxMenuDrawer} disableGutters maxWidth="md">
        <Paper elevation={0} sx={{ zIndex: 1000, position: "sticky", top: 24 }}>
          <InputBusca
            label=""
            setFiltro={setBusca}
            desativarPesquisaLenta
            fullWidth
            sx={sxBarraBusca}
          />
        </Paper>
        <List sx={{ minHeight: "50vh" }}>
          {ITENS_EXCEDENTES.filter(
            (ele) => _.toLower(ele.texto).search(_.toLower(busca)) !== -1
          ).map((item, idx) => (
            <ItemMenu key={idx} {...item} />
          ))}
        </List>
      </Container>
    );
  }

  return (
    <>
      <AppBar position="fixed" style={sxAppBar}>
        <Box clone alignItems="center" justifyContent="space-around">
          <Toolbar disableGutters>
            {ITENS_MENU.map((obj, idx) => (
              <Box onClick={obj.onClick} sx={sxItemAppBar} key={idx}>
                <Icone icone={obj.icone} />
                <Typography variant="caption">{obj.texto}</Typography>
              </Box>
            ))}
          </Toolbar>
        </Box>
      </AppBar>
      <DrawerExibicao corpo={corpo} fecharDrawer={() => setExibir(false)} />
    </>
  );
};
// Para os itens excedentes do menu
const ItemMenu = ({ onClick, texto, icone }) => {
  const {
    palette: { mode },
  } = useTheme();

  return (
    <ListItemButton divider onClick={onClick}>
      <ListItemIcon>
        <Icone sx={sxIcone} icone={icone} />
      </ListItemIcon>
      <ListItemText
        primaryTypographyProps={{
          color: mode === "dark" ? "white" : "primary.main",
        }}
        primary={texto}
      />
    </ListItemButton>
  );
};

export default memo(BarraInferior);
